import React from 'react';
import loadingGif from '../img/loading.gif';

class Message extends React.Component {
    render() {
        const messageBody = this.props.loading ? (
            <img src={loadingGif} style={{ height: 120 }} alt="Lade..." />
        ) : (
            this.props.message
        );

        return (
            <div>
                <div className="subheader">
                    <div>{this.props.header}</div>
                    <div className="separator">&nbsp;</div>
                </div>
                {messageBody}
            </div>
        );
    }
}

export default Message;


// WEBPACK FOOTER //
// ./src/components/Message.js